import { useTranslate } from '@ur-solutions/react-hooks'
import React from 'react'
import { isMobileOnly } from 'react-device-detect'
import {
  Header,
  InfoBox,
  Section,
  SectionHeader,
  SettingsWrapper,
} from '../components/common'
import { ModuleResponsibleUsers } from '../components/ModuleResponsibleUsers'
import {
  Module,
  ModuleOptionCards,
  ModuleOptionsValue,
} from 'modules/companies'
import { useModuleConfig } from 'utils/hooks'
import { ResponsibleUserNotificationThreshold } from '../components/InfringementsSettings/ResponsibleUserNotificationThreshold'

interface InfringementsSettingsProps {}

export const InfringementsSettings: React.FC<
  InfringementsSettingsProps
> = () => {
  const translations = useTranslate({
    info1: 'settings.info.infringements-data-1',
    moduleOptions: 'settings.module-options',

    notificationLimitTitle: 'settings.infringements.notification-limit-title',
    notificationDisclaimer:
      'settings.infringements.notification-limit-disclaimer',
  })

  const { moduleOptions } = useModuleConfig(Module.INFRINGEMENTS)

  const infringementToIssueActive = moduleOptions.some(
    option =>
      option.name === ModuleOptionsValue.CREATE_ISSUE_FROM_INFRINGEMENTS &&
      option.active
  )

  return (
    <SettingsWrapper
      grid={{
        flow: 'row',
      }}
    >
      <InfoBox initCollapsed={isMobileOnly}>
        <p>{translations.info1}</p>
      </InfoBox>

      <ModuleResponsibleUsers module={Module.INFRINGEMENTS} />

      <Section>
        <Header>
          <SectionHeader>{translations.moduleOptions}</SectionHeader>
        </Header>
        <ModuleOptionCards module={Module.INFRINGEMENTS} />
      </Section>
      {infringementToIssueActive && (
        <Section>
          <Header>
            <SectionHeader>{translations.notificationLimitTitle}</SectionHeader>
          </Header>
          <p>{translations.notificationDisclaimer}</p>
          <ResponsibleUserNotificationThreshold />
        </Section>
      )}
    </SettingsWrapper>
  )
}
